<template>
<div class="modal fade" id="besoinsModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">BESOINS FINANCIERS</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" id="close22" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form class="form" @submit.prevent="submit" >
                        <div class="form-group">
                            <div v-html="dossier.presentation_besoins_financiers"></div>
                            <hr/>
                            <ckeditor :editor="editor" v-model="presentation_besoins_financiers" :config="editorConfig"></ckeditor>
                            
                        </div>
                       <button class="btn btn-success" type="submit">ENREGISTRER</button>
                 </form>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from "axios";
import { createToaster } from "@meforma/vue-toaster";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default{
    name:'BesoinsComponent',
    props:{
            dossier:{
                'type':Object,
                'required':true,
            }
        },
        data(){
            return {
                presentation_besoins_financiers:this.dossier.presentation_besoins_financiers,
                toaster: createToaster({ position:'top-right'}),
                editor: ClassicEditor,
                editorConfig: this.editorConfig

                }
        },
        methods:{
            submit(){
                document.getElementById('close22').click();
                let loader = this.$loading.show({
                    container: this.fullPage ? null : this.$refs.formContainer,
                    canCancel: false,
                });
                let form = new FormData();
                form.append("presentation_besoins_financiers",this.presentation_besoins_financiers);
                form.append("seed_id",this.dossier.id);
                axios.post(this.path+'owner/seeds/besoins-financiers',form,{
                    headers:{
                        'Accept':'multipart/form-data'
                    }
                })
                .then((res)=>{
                    console.log(res)
                    this.$emit('ended');
                    loader.hide()
                })
                .catch((err)=>{
                    loader.hide()
                    this.toaster.error("Une erreur est survenue lors de l'enregistrement !");
                    console.log(err)
                })
                .finally()
            }
        }
    }

</script>

<style scoped>


</style>